import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  organizations: [],
  currentOrganization: null,
  isLoading: false,
  error: null,
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    fetchOrganizationsStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchOrganizationsSuccess: (state, action) => {
      state.isLoading = false;
      state.organizations = action.payload;
    },
    fetchOrganizationsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setCurrentOrganization: (state, action) => {
      state.currentOrganization = action.payload;
    },
    clearCurrentOrganization: (state) => {
      state.currentOrganization = null;
    },
  },
});

export const {
  fetchOrganizationsStart,
  fetchOrganizationsSuccess,
  fetchOrganizationsFailure,
  setCurrentOrganization,
  clearCurrentOrganization,
} = organizationSlice.actions;

export default organizationSlice.reducer;